import { useCallback } from 'react';
import { PatientAddVasModal } from '../../../virtual-appointments/PatientAddVasModal';
import type { ActionRunnerProps } from '../types';

// The Actions tab's entry: no completion page here, so the outcome is a toast and a refresh.
function OpenVasNowAction({ patientId, onBack, onDataChange }: ActionRunnerProps) {
    const handleAdded = useCallback(() => {
        onDataChange?.();
        onBack();
    }, [onDataChange, onBack]);

    return <PatientAddVasModal patientId={patientId} onClose={onBack} onAdded={handleAdded} />;
}

export { OpenVasNowAction };
